module.exports = __webpack_public_path__ + "img/B5.89c14e9a.png";